/*
 * @copyright Copyright (c) 2019 Julius Härtl <jus@bitgrid.net>
 *
 * @author Julius Härtl <jus@bitgrid.net>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */

/**
 * Callback that should be executed after the document is ready
 *
 * @param callback
 */
import { generateUrl } from '@nextcloud/router'

const documentReady = function(callback) {
	const fn = () => setTimeout(callback, 0)
	if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
		fn()
	} else {
		document.addEventListener('DOMContentLoaded', callback)
	}
}

const _baseUrl = generateUrl('/apps/text')
const endpointUrl = (endpoint, isPublic = false) => {
	if (isPublic) {
		return `${_baseUrl}/public/${endpoint}`
	}
	return `${_baseUrl}/${endpoint}`
}

export {
	documentReady,
	endpointUrl,
}
